import { useEffect } from "react";

export default function TwitchChatbotCallbackPage() {
  useEffect(() => {
    let code = null;
    let url = null;
    if (window.location.search.match(/code=(\w+)/)) {
      url = new URL(window.location.href);
      code = url.searchParams.get("code");
    }

    if (code) {
      if (window.opener) {
        //do something with the oauth token
        window.opener.postMessage({ code }, "*");
        window.close();
      } else {
        console.log(url);
      }
    }
  }, []);

  return null;
}
